import React from 'react';

import cx from 'classnames';

import { X } from 'components/shared/Icon/phosphorIcons';
import { useNavigation } from 'detailsv2/LandingV2/Header/NavBar/functions';
import { ELandingHeaderLayout } from 'detailsv2/LandingV2/types';
import { getPrefix } from 'detailsv2/LandingV2/utils';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import i18n from 'i18n';

import { INavigationMenuProps } from '../types';
import { useNavigationHeight, useVerticalAutoScroll } from './functions';
import s from './index.module.css';
import { LinkItem } from './LinkItem';

export const NavigationMenu = ({ isOpen, setClose, config }: INavigationMenuProps) => {
  const { links, activePageId } = useNavigation();
  const { navigationContainerHeight } = useNavigationHeight(config.layout);
  const isIphone = 'iPhone'.match(navigator.platform);
  const { isTabletOrMobile } = useMediaBreakpoints();

  const { navRef } = useVerticalAutoScroll(activePageId, links);
  const isFullWidthHeader = config.layout !== ELandingHeaderLayout.HalfWidth;

  return (
    <>
      <div
        className={cx(
          s.navigationContainer,
          isFullWidthHeader && s.fullWidthNavigationContainer,
          isOpen && s.isVisible,
        )}
      >
        <div className={cx(s.navigationContent)}>
          {isTabletOrMobile && (
            <div className={s.closeBurgerIcon} onClick={() => setClose(false)}>
              <X weight="regular" size={20} />
            </div>
          )}
          <div
            data-block
            className={cx(
              s.navigationHeader,
              isFullWidthHeader && !isTabletOrMobile && s.fullWidthNavigationHeader,
              getPrefix('landing-page-burger-header'),
            )}
          >
            {i18n.t('proposal_content.table_of_contents')}
          </div>
          <div
            className={cx(s.hideNavigation, isFullWidthHeader && !isTabletOrMobile && s.fullWidthHideNavigation)}
          ></div>
          <div
            ref={navRef}
            className={cx(
              s.navigation,
              isFullWidthHeader && !isTabletOrMobile && s.fullWidthNavigation,
              isIphone && s.iPhoneNavigation,
              getPrefix('landing-page-burger-nav'),
            )}
            style={{ height: navigationContainerHeight }}
          >
            {links.map((link) => {
              return (
                <LinkItem
                  key={link.id}
                  link={link}
                  isHidden={link.isHidden}
                  onClick={() => {
                    link.onClick(link.id);
                    setClose(false);
                  }}
                  activePageId={activePageId}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
